import { render, staticRenderFns } from "./freegis.vue?vue&type=template&id=c82cbe64&scoped=true&"
import script from "./freegis.vue?vue&type=script&lang=js&"
export * from "./freegis.vue?vue&type=script&lang=js&"
import style0 from "./freegis.vue?vue&type=style&index=0&id=c82cbe64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82cbe64",
  null
  
)

export default component.exports